import React, { useEffect } from "react";

import { Box } from "@mui/material";
import TierListLayout from "../Components/TierList/TierListLayout";
import SeoHead from "../Components/SEO/SeoHead";
import { BASE_SITE_URL } from "../config";
import { useTranslation } from "react-i18next";

const MainContent = (props) => {
  const { t } = useTranslation();

  useEffect(() => {
    props.mainFunctions.loadMusicData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Redirect old query-param URLs to clean URLs
  useEffect(() => {
    const pathname = props.location?.pathname || "";
    const search = props.location?.search || "";
    if (pathname === "/TierList" && search) {
      const params = new URLSearchParams(search);
      const lt = (params.get("listType") || "albums").toLowerCase();
      const gb = params.get("groupBy") || params.get("year") || params.get("letter");
      const cleanUrl = gb
        ? `/tier-list/${lt}/${encodeURIComponent(gb)}`
        : `/tier-list/${lt}`;
      if (props.navigate) {
        props.navigate(cleanUrl, { replace: true });
      }
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const { page } = props.state;
  const pathname = props.location?.pathname || "";
  const pathMatch = pathname.match(/^\/tier-list\/(albums|songs|artists|year)(?:\/(.+))?$/i);

  let groupByValue: string | null;
  if (pathMatch) {
    groupByValue = pathMatch[2] ? decodeURIComponent(pathMatch[2]) : null;
  } else {
    const searchParams = new URLSearchParams(props.location?.search || "");
    groupByValue = searchParams.get("groupBy") || searchParams.get("year") || searchParams.get("letter");
  }

  const listType = props.state.listType;
  const seoPath = pathMatch
    ? pathname
    : `/tier-list/${listType.toLowerCase()}`;

  const hasGroupFilter = Boolean(groupByValue);
  const queryTitle = (() => {
    if (listType === "Year" && hasGroupFilter) {
      return `${groupByValue} Music Tier List | Best Albums of ${groupByValue}`;
    }
    if (listType === "Artists" && hasGroupFilter) {
      return `Music Tier List Artists | Letter ${groupByValue}`;
    }
    if (listType === "Albums" && hasGroupFilter) {
      return `${groupByValue} Album Tier List | Rank ${groupByValue} Albums`;
    }
    if (listType === "Songs" && hasGroupFilter) {
      return `${groupByValue} Song Tier List | Rank ${groupByValue} Songs`;
    }
    return undefined;
  })();

  const seoTitle = queryTitle || t("home.seoTitle");
  const seoDescription = hasGroupFilter
    ? `Create and share your ${groupByValue} ${listType.toLowerCase()} tier list. Rank your favorite ${groupByValue} ${listType.toLowerCase()} with high-quality cover art on Music Tier List.`
    : t("home.seoDescription");
  if (page !== "homePage") {
    props.basicFunctions.updateState({
      page: "homePage",
      typePrefix: "Tier List",
    });
  }

  const homeStructuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    name: queryTitle || t("common.siteName"),
    url: `${BASE_SITE_URL}${seoPath}`,
    description: seoDescription,
    applicationCategory: "Multimedia",
    operatingSystem: "Web",
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "USD",
    },
  };
  return (
    <Box
      id="main-content-page"
      key={`mainContentBoxDiv`}
      sx={{
        backgroundColor: "background.default",
        color: "text.primary",
      height: "100vh",
      overflow: "hidden",
    }}
  >
      <SeoHead
        title={seoTitle}
        description={seoDescription}
        path={seoPath}
        keywords={(
          t("home.keywords", { returnObjects: true }) as string[]
        ).concat(hasGroupFilter ? [groupByValue as string, `${groupByValue} tier list`, `${groupByValue} ${listType.toLowerCase()} ranking`] : [])}
        structuredData={homeStructuredData}
      />
    <TierListLayout {...props} />
  </Box>
);
};

export default MainContent;
